export const inviteLink = (code) => `${window.location.origin}/join/${code}`;

export async function shareInvite(code, text) {
  const url = inviteLink(code);
  if (navigator.share) {
    try {
      await navigator.share({ title: "Snetch", text, url });
      return "shared";
    } catch (e) {
      if (e?.name === "AbortError") return "aborted";
    }
  }
  await navigator.clipboard?.writeText(url);
  return "copied";
}
